import {
  CategoryActionTypes, CategoryState, SET_CATEGORY, CategoryTypes,
} from './types';

export function requestCategory(): CategoryActionTypes {
  return {
    type: CategoryTypes.CATEGORY_REQUEST,
  };
}

export function setCategory(payload: Array<CategoryState>): CategoryActionTypes {
  return {
    payload,
    type: SET_CATEGORY,
  };
}
